module.exports = __webpack_public_path__ + "c_static/img/2-2手机天猫收藏夹.ca99632.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/4-回购特卖入口/2-2手机天猫收藏夹.jpg
// module id = kn42
// module chunks = 33